const ALLOWED_DOMAINS = ["platform.sh", "upsun.com"];

export const isInternalUser = (email: string = "") => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (regex.test(email)) {
    const domain = email.split("@")[1];
    return ALLOWED_DOMAINS.includes(domain);
  }
  return false;
};
